import ReferencePathService from '~/services/referencePathServices/referencePathService'
import { IReferencePathNodeApiEndPoint, IReferencePathNodeSpecific } from '~/interfaces/referencePathInterfaces'
import { GenericType } from '~/interfaces/genericTypeInterfaces'
import { ModelType } from '~/enums/modelType'
import EndPoint from '../../../formability/organization_settings/models/connections/endPoint'
import { ReferenceNodeType } from '~/enums/referenceNodeType'

export default class ApiEndPointPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.EndPoint

  constructor(private endPointNode: IReferencePathNodeApiEndPoint) {
    super()
  }

  get label(): string {
    return this.endPointNode.reference()?.name
  }

  get nodes(): IReferencePathNodeApiEndPoint[] {
    return [this.endPointNode]
  }

  reference(): EndPoint {
    return EndPoint.repo.findById(this.endPointNode.reference_id)
  }

  get referenceGenericModelType(): GenericType {
    return this.reference()?.genericType
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision = (node.reference_type === ReferenceNodeType.ApiMessageType || node.reference_type === ReferenceNodeType.ApiHeader || node.reference_type === ReferenceNodeType.ApiURLParameter)
    this.debugCanLinkTo('ApiEndPointPathService', this.endPointNode, node, decision)
    return decision
  }

  get referenceIsCollection(): boolean {
    return false
  }
}